import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

export default function RightArrow({ onClick, ...rest }) {    
  const {
    onMove,
    carouselState: { currentSlide, deviceType }
  } = rest;
  // onMove means if dragging or swiping in progress.
  return <button
            onClick={() => onClick()}
            // disabled={!loop && firstIndex}
            className="!absolute top-2/4 right-0 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white grid place-items-center"
          >
            <ArrowRightIcon strokeWidth={2} color="black" className="ml-5 h-7 w-7" />
          </button>;
}
